<template>
  <button id="NUMBER_2" name="2" class="btn num-btn" data-vcode="NUMBER_2" aria-label="2 ABC">
    <div class="digit">2</div>
    <div class="letters">ABC</div>
  </button>
</template>
<script>
export default {};
</script>
